import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/about/About'
import People from '@/components/about/Detail'
import Projects from '@/components/projects/Projects'
import ProjectDetail from '@/components/projects/Detail'
import Branding from '@/components/branding/Branding'
import BrandingDetail from '@/components/branding/Detail'
import Introduction from '@/components/branding/Introduction'
import Services from '@/components/branding/Services'
import Articles from '@/components/writings/Articles'
import Publications from '@/components/writings/Publications'
import Contact from '@/components/Contact'


Vue.use(Router)

const router =  new Router({
  routes: [
    {path: '/',component: Home},
    {path: '/about',component: About},
    {path: '/people/:id',component: People},
    {path: '/projects/:id',component: Projects},
    {path: '/projects/detail/:id',component: ProjectDetail},
    {path: '/branding',component: Branding},
    {path: '/branding/detail/:id',component: BrandingDetail},
    {path: '/introduction',component: Introduction},
    {path: '/services',component: Services},
    {path: '/articles',component: Articles},
    {path: '/publications',component: Publications},
    {path: '/contact',component: Contact},

    {path: '*',component: Home}
  ],
  mode:"hash",
  linkActiveClass:'cur',
  // 对于页面跳转，全部都返回到页面顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      $('#navbarToggler').removeClass('show')
      $('.navbar-toggler').addClass('collapsed')
      $('.navbar-toggler').attr('aria-expanded','false')
      return { x: 0, y: 0 }
    
    }
  }
})

// router.beforeEach((to,from,next) => {
//   $('body').removeClass('navOpen')
//   next()
// })


export default router



// WEBPACK FOOTER //
// ./src/router/index.js